export const INDIAN_STATES = [
  {
    name: "Andhra Pradesh",
    value: "Andhra Pradesh",
  },
  {
    name: "Arunachal Pradesh",
    value: "Arunachal Pradesh",
  },
  {
    name: "Assam",
    value: "Assam",
  },
  {
    name: "Bihar",
    value: "Bihar",
  },
  {
    name: "Chhattisgarh",
    value: "Chhattisgarh",
  },
  {
    name: "Goa",
    value: "Goa",
  },
  {
    name: "Gujarat",
    value: "Gujarat",
  },
  {
    name: "Haryana",
    value: "Haryana",
  },
  {
    name: "Himachal Pradesh",
    value: "Himachal Pradesh",
  },
  {
    name: "Jharkhand",
    value: "Jharkhand",
  },
  {
    name: "Karnataka",
    value: "Karnataka",
  },
  {
    name: "Kerala",
    value: "Kerala",
  },
  {
    name: "Madhya Pradesh",
    value: "Madhya Pradesh",
  },
  {
    name: "Maharashtra",
    value: "Maharashtra",
  },
  {
    name: "Manipur",
    value: "Manipur",
  },
  {
    name: "Meghalaya",
    value: "Meghalaya",
  },
  {
    name: "Mizoram",
    value: "Mizoram",
  },
  {
    name: "Nagaland",
    value: "Nagaland",
  },
  {
    name: "Odisha",
    value: "Odisha",
  },
  {
    name: "Punjab",
    value: "Punjab",
  },
  {
    name: "Rajasthan",
    value: "Rajasthan",
  },
  {
    name: "Sikkim",
    value: "Sikkim",
  },
  {
    name: "Tamil Nadu",
    value: "Tamil Nadu",
  },
  {
    name: "Telangana",
    value: "Telangana",
  },
  {
    name: "Tripura",
    value: "Tripura",
  },
  {
    name: "Uttarakhand",
    value: "Uttarakhand",
  },
  {
    name: "Uttar Pradesh",
    value: "Uttar Pradesh",
  },
  {
    name: "West Bengal",
    value: "West Bengal",
  },
  {
    name: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  {
    name: "Chandigarh",
    value: "Chandigarh",
  },
  {
    name: "Dadra and Nagar Haveli",
    value: "Dadra and Nagar Haveli",
  },
  {
    name: "Daman & Diu",
    value: "Daman & Diu",
  },
  {
    name: "Delhi",
    value: "Delhi",
  },
  {
    name: "Jammu & Kashmir",
    value: "Jammu & Kashmir",
  },
  {
    name: "Ladakh",
    value: "Ladakh",
  },
  {
    name: "Lakshadweep",
    value: "Lakshadweep",
  },
  {
    name: "Puducherry",
    value: "Puducherry",
  },
];

export const DYNAMIC_COLLECTION_FIELDS = [
  {
    label: "PRICE",
    value: "PRICE",
  },
  {
    label: "DISCOUNT PERCENTAGE",
    value: "DISCOUNT_PERCENTAGE",
  },
  {
    label: "DISCOUNT FIXED",
    value: "DISCOUNT_FIXED",
  },
];

export const DYNAMIC_COLLECTION_CONDITION = [
  {
    label: "Greater Than Or Equal (>=)",
    value: "$gte",
  },
  {
    label: "Greater (>)",
    value: "$gt",
  },
  {
    label: "Less Than Or Equal (<=)",
    value: "$lte",
  },
  {
    label: "Less Than (<)",
    value: "$lt",
  },
  {
    label: "Equal To (==)",
    value: "$eq",
  },
  {
    label: "Not Equal To (!=)",
    value: "$ne",
  },
];
